import { useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import logoHorizontal from '../../assets/images/logo-horizontal.svg';
import arrowDownSmall from '../../assets/icons/arrow-down-small-white-icon.svg';
import settingsIcon from '../../assets/icons/settings-outlined-icon.svg';
import logoutIcon from '../../assets/icons/logout-icon.svg';
import { AccountSettings } from '../../components/other/AccountSettings';
import { useAppSelector } from '../../store/hooks/hooks';
import { store } from '../../store/store';
import { logOutUser } from '../../store/slice/KorisnikSlice';
import JWTTokenService from '../../common/service/JWTTokenService';

export const AppLayout = () => {
  const [userIsOpen, setUserIsOpen] = useState<boolean>(false);
  const [modalOn, setModalOn] = useState<boolean>(false);

  const pathname = window.location.pathname;
  const [selectedTab, setSelectedTab] = useState<string>(pathname);

  const korisnik = useAppSelector((state) => state.korisnik);

  const navigate = useNavigate();

  const userLogout = () => {
    store.dispatch(logOutUser());
    JWTTokenService.logout();
  };
  return (
    <>
      <div className='navigation font-h5-regular'>
        {modalOn && <AccountSettings setModalOn={setModalOn}></AccountSettings>}
        <div className='navigation__box'>
          <div className='flex-center relative'>
            <picture
              className='navigation__box__horizontal-logo pointer'
              onClick={() => {
                navigate('/');
                setSelectedTab('/');
              }}
            >
              <img className='navigation__box__horizontal-logo__img' src={logoHorizontal} alt='logo-horizontal' />
            </picture>
            <div className='beta-version color-white font-light font-italic'>
              <span>Beta</span>
            </div>
          </div>
          <ul className='navigation__box__pages'>
            <Link className={`navigation__box__pages__page ${selectedTab === '/' ? 'active' : ''}`} onClick={() => setSelectedTab('/')} to={'/'}>
              Dashboard
            </Link>
            <Link
              className={`navigation__box__pages__page ${selectedTab === '/stats' ? 'active' : ''}`}
              onClick={() => setSelectedTab('/stats')}
              to={'stats'}
            >
              Stats
            </Link>
            <Link
              className={`navigation__box__pages__page ${selectedTab === '/companies' ? 'active' : ''}`}
              onClick={() => setSelectedTab('/companies')}
              to={'companies'}
            >
              Companies
            </Link>
            <Link
              className={`navigation__box__pages__page ${selectedTab === '/users' ? 'active' : ''}`}
              onClick={() => setSelectedTab('/users')}
              to={'users'}
            >
              Users
            </Link>
            <Link
              className={`navigation__box__pages__page ${selectedTab === '/processes' ? 'active' : ''}`}
              onClick={() => setSelectedTab('/processes')}
              to={'processes'}
            >
              Processes
            </Link>
            <Link
              className={`navigation__box__pages__page ${selectedTab === '/training' ? 'active' : ''}`}
              onClick={() => setSelectedTab('/training')}
              to={'training'}
            >
              Training
            </Link>
            <Link
              className={`navigation__box__pages__page ${selectedTab === '/faq' ? 'active' : ''}`}
              onClick={() => setSelectedTab('/faq')}
              to={'FAQ'}
            >
              FAQ
            </Link>
            <Link
              className={`navigation__box__pages__page ${selectedTab === '/settings' ? 'active' : ''}`}
              onClick={() => setSelectedTab('/settings')}
              to={'settings'}
            >
              Settings
            </Link>
          </ul>
        </div>
        <div className='navigation__account'>
          <div className={`navigation__account__user ${userIsOpen ? 'bg-dark-300' : ''}`} onClick={() => setUserIsOpen(!userIsOpen)}>
            <span className='navigation__account__user__text'>
              {korisnik.first_name} {korisnik.last_name}
            </span>
            <img className={`${userIsOpen ? 'rotate-180' : ''}`} src={arrowDownSmall} alt='' />
          </div>
          {userIsOpen && (
            <div className='navigation__account__dropdown'>
              <div
                onClick={() => {
                  setModalOn(true);
                  setUserIsOpen(false);
                }}
                className='navigation__account__dropdown__item'
              >
                <img className='navigation__account__dropdown__item__img' src={settingsIcon} alt='' />
                <span className='navigation__account__dropdown__item__text'>Account settings</span>
              </div>
              <div onClick={() => userLogout()} className='navigation__account__dropdown__item'>
                <img className='navigation__account__dropdown__item__img' src={logoutIcon} alt='' />
                <span className='navigation__account__dropdown__item__text'>Logout</span>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='full-width-line-dark-300 padding-bottom-6'></div>
      <Outlet />
    </>
  );
};
